import React from "react";
import { Select, Spin, Table, Alert } from "antd";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import CustomTab from "../../../components/shared/tab/TabComponent";
import { useQuizReport } from "../../../hooks/AdminHooks/useQuizReport";
import { getUserQuizReportColumns, getCourseQuizReportColumns } from "../../../utility/coloumnConstants";
import PageLoader from "../../../components/global/Loader/PageLoader";

const { Option } = Select;

const QuizReportDashboard = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const urlUserId     = searchParams.get("userId");
  const urlUserName   = searchParams.get("userName");
  const urlCourseId   = searchParams.get("courseId");
  const urlCourseName = searchParams.get("courseName");
  const [activeTab, setActiveTab] = useState("1");

  const {
    users,
    courses,
    userReport,
    courseReport,
    selectedUser,
    selectedCourse,
    loadingFilters,
    loadingReport,
    handleUserChange,
    handleCourseChange,
    fetchCoursesIfNeeded,
  } = useQuizReport({ urlUserId, urlCourseId });

  const openDetailPage = (userId, courseId, courseName, userName) => {
    const params = new URLSearchParams({
      userId,
      courseId,
      ...(courseName && { courseName }),
      ...(userName   && { userName }),
    });
    navigate(`/quiz-attempt-details?${params.toString()}`);
  };

  const userReportColumns   = getUserQuizReportColumns(users, selectedUser, openDetailPage);
  const courseReportColumns = getCourseQuizReportColumns(courses, selectedCourse, openDetailPage);

  const selectedUserName = (() => {
    if (urlUserName) return decodeURIComponent(urlUserName);
    const user = users.find((u) => u.userId === selectedUser);
    return user ? `${user.firstName} ${user.lastName}` : "";
  })();

  const selectedCourseName = (() => {
    if (urlCourseName) return decodeURIComponent(urlCourseName);
    return courses.find((c) => c.courseId === selectedCourse)?.title ?? "";
  })();

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === "2") {
      fetchCoursesIfNeeded();
    }
  };

  const tabList = [
  { key: "1", label: "By User" },
  { key: "2", label: "By Course" },
];

return (
  <div>
      <PageLoader visible={loadingFilters || loadingReport} />
    {(urlUserId || urlUserName) && (
      <Alert
        message={`Showing quiz reports for user: ${selectedUserName}`}
        type="info"
        showIcon
        className="mb-4"
      />
    )}

    {(urlCourseId || urlCourseName) && (
      <Alert
        message={`Showing quiz reports for course: ${selectedCourseName}`}
        type="info"
        showIcon
        className="mb-4"
      />
    )}
    <div className="p-6 flex flex-col border border-[#E8E8E8] rounded-[10px] shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)]">
      <div className="flex flex-col gap-6">
        <h1 className="text-[#e74860] text-[1.75rem] font-normal">
          Quiz Report
        </h1>
    <div className="flex items-center justify-between">
      <CustomTab entries={tabList} onChange={handleTabChange} />

      {activeTab === "1" && (
        <Select
          showSearch
          allowClear
          placeholder="Select User"
          className="w-[12rem] h-[2.5rem]"
          onChange={handleUserChange}
          value={selectedUser}
          optionFilterProp="label"
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        >
          {users.map((u) => (
            <Option key={u.userId} value={u.userId} label={`${u.firstName} ${u.lastName}`}>
              {u.firstName} {u.lastName}
            </Option>
          ))}
        </Select>
      )}

      {activeTab === "2" && (
        <Select
          showSearch
          allowClear
          placeholder="Select Course"
          className="w-[12rem] h-[2.5rem]"
          onChange={handleCourseChange}
          value={selectedCourse}
          optionFilterProp="label"
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        >
          {courses.map((c) => (
            <Option key={c.courseId} value={c.courseId} label={c.title}>
              {c.title}
            </Option>
          ))}
        </Select>
      )}
    </div>
    </div>
    <div>
      {activeTab === "1" && (
          <Table
            rowKey={(record) => record.courseOutDTO.courseId}
            dataSource={userReport}
            columns={userReportColumns}
            className="top-table-radius"
            bordered
            pagination={false}
          />
      )}

      {activeTab === "2" && (
          <Table
            rowKey={(record) => record.userId}
            dataSource={courseReport}
            columns={courseReportColumns}
            className="top-table-radius"
            bordered
            pagination={false}
          />
      )}
    </div>
  </div>
  </div>
);
};

export default QuizReportDashboard;